import { Route } from '../../../routes';

export interface MenuRoute extends Route {
  ignoreMenu?: boolean;
  children?: MenuRoute[];
  visibleOnlyWithAccount?: boolean;
}

export const routes: MenuRoute[] = [
  {
    name: 'Notifications',
    route: {
      path: 'notifications',
      element: <div />,
    },
    children: [
      {
        name: 'Notification',
        route: {
          path: ':id',
          element: <div />,
        },
      },
    ],
  },
];
